/*
 * Post-discount.ts
 * Description: Includes the declaration
 * of the function for creating a discount
 */

// Importing Axios for HTTP requests
import Axios from 'axios';
// Importing required global variables
import {APIURL, EmailTaken} from '@/ts/variables';
// Importing an interface
import {Discount} from '@/ts/discounts/validate-discount';

/**
 * Creating a discount
 *
 * @return {Object} Promise - when the request has been fulfilled
 * @param {Discount} data - discount data
 * @param {String} slug - slug of the restaurant
 */
export function postDiscount(data: Discount, slug: string) {
    const jwt = localStorage.getItem('jwt');
    return new Promise((resolve, reject) => {
        Axios({
            url:  APIURL + 'restaurants/' + slug + '/discounts',
            method: 'post',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data,
        }).then(() => {
            resolve();
        }).catch((error) => {
            reject(error);
        });
    });
}
